export const panelDomainList = [
  { title: "Sales", value: "Sales" },
  { title: "Marketing", value: "Marketing" },
];

